// Palette partagée par tous les écrans MFA (Activation, Vérification, Config, Admin, Challenge).
// Centraliser ces valeurs évite qu'un nouvel écran reparte sur une couleur différente
// (c'est ce qui était arrivé à MfaVerifyPage.tsx, resté en bleu #116599).
export const mfaTheme = {
  primary: '#116599',       // icônes actives, accents
  primaryDark: '#0d4a70',   // titres, texte fort
  primaryHover: '#0d4a70',  // hover des boutons pleins
  primaryBg: '#edf5fa',     // fonds de card "info"
  primaryBorder: '#dbe7f0', // bordures de card "info"
  pageBg: '#f5f5f5',        // fond de page plein écran
  textMuted: '#5d6b78',
  textMuted2: '#4e5a68',
  inactive: '#999999',
} as const;